<template>
  <h2 class="nodata pt30" v-show="nodataflag">暂无数据</h2>
</template>

<script>
export default {
  name: 'index',
  props: ['nodataflag']
}
</script>

<style lang="scss" scoped>
.nodata{
  font-size: 16px;
  text-align: center;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/nodata/index.vue